import AttachmentPreferencesOption from 'owa-attachment-preferences-option/lib/AttachmentPreferencesOption';
import StorageAccountsOption from 'owa-storage-accounts-option/lib/StorageAccountsOption';
var attachmentsSubCategory = {
    key: 'attachments',
    titleStringKey: 'optionSubcategory_attachments',
    options: [AttachmentPreferencesOption, StorageAccountsOption],
};
export default attachmentsSubCategory;
//# sourceMappingURL=attachmentsSubCategory.js.map